<script lang="ts" setup>
import { ref, onMounted } from "vue";
import { getKZValue } from "@/DataHelper";
import { AufgabeStatus, AufgabeStatusZuordnungAufgabe } from "../ChartTypesAndFunctions";
import AUApi from "@/api";
import { begriffBezeichnung } from "@/local";
import { getSiteData, goBack } from "@/NavigationHelper";
import DashboardAufgabeBoardItem from "@/components/dashboard/AufgabeBoardItem.vue";
const emit = defineEmits(["back"]);
export declare interface DialogPopupSiteParams {
  zusatzInfo: AufgabeStatusZuordnungAufgabe;
  aufgabenDefinition: QueryResponse;
  aic: number;
  zeitbereich: APIZeitbereich;
  setTitle: (title: string) => void;
  hideTitle: (hide: boolean) => void;
  page: boolean;
}

let siteData = getSiteData();
let zusatzInfo: AufgabeStatusZuordnungAufgabe;
let aic = ref<number>(0);
let initialized = ref<boolean>(false);
let aufgabenDefinition: QueryResponse;
let title = ref<string>("");

let aufgabe = ref<ALLAufgabe>();
let zeitbereich: APIZeitbereich;

function showTitle() {
  return siteData.page;
}

onMounted(() => {
  try {
    if (siteData) {
      if (siteData.zusatzInfo) {
        zusatzInfo = siteData.zusatzInfo;
        zeitbereich = siteData.zeitbereich;
      }
      if (siteData.aic) {
        aic.value = siteData.aic;
      }
      aufgabenDefinition = siteData.aufgabenDefinition;
    }
    if (!zusatzInfo?.aic) {
      return;
    } else {
      aufgabe.value = (AUApi.Current.Begriff.find(
        (b) => b.gruppe === "Aufgabe" && b.aic === zusatzInfo!.aic
      ) as unknown) as ALLAufgabe;
      if (!aufgabe) {
        alert(begriffBezeichnung("Web_keineDaten_gefunden", "keine Daten gefunden"));
      }
    }
  } finally {
    initialized.value = true;
  }
});
function hideDialogTitel() {
  siteData.hideTitle(true);
}
function setDialogTitle(title: string) {
  if (siteData.page) {
    title = title;
  } else {
    siteData.setTitle(title);
  }
}
</script>
<template>
  <div v-if="initialized" style="min-height: 200px; width: 100%">
    <!-- wenn titel toolbar mit Zurück-Knopf -->
    <v-toolbar
      dark
      density="compact"
      class="dvhBackground mt-2"
      v-if="showTitle"
      :title="title"
    >
      <v-spacer></v-spacer>
      <v-btn color="white" icon="mdi-close" @click="goBack()"></v-btn>
    </v-toolbar>
    <DashboardAufgabeBoardItem
      v-if="aufgabe"
      :aufgabe="aufgabe"
      :aufgabenDefinition="aufgabenDefinition"
      :zeitbereich="zeitbereich"
      :aic="aic"
      @dashboardItemTitle="setDialogTitle"
      @back="goBack()"
      @hideDialogTitel="hideDialogTitel"
    />
  </div>
</template>
